import { Button, Checkbox, Col, Card, Form, Input, Row, Collapse, Select, notification, Modal, Table, Space, theme } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined, SettingOutlined, ArrowLeftOutlined, UserOutlined, VideoCameraOutlined } from "@ant-design/icons";
import { Fragment, useEffect, useState } from "react";
import * as animationData from "../serviceanim.json";
import Lottie from "react-lottie";
import { validateEmail } from "../utils/methods";
import axios from "axios";
import { API_ENDPOINT } from "../api/endPoint";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const { useToken } = theme;
  const { token } = useToken();
  const [api, contextHolder] = notification.useNotification();
  const [isCreating, setIsCreating] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [fpToken, setFpToken] = useState("");
  const navigate = useNavigate();

  const onFinish = async (values) => {
    let { email, password, otp, passwordRepeat } = values;

    if (!validateEmail(email)) {
      api.error({
        message: "eGlu Service Forgot Password",
        description: "Email ID is not valid.",
      });
      return;
    }
    try {
      setIsCreating(true);
      if (otpSent) {
        if (password != passwordRepeat) {
          setIsCreating(false);
          api.error({
            message: "eGlu Service Forgot Password",
            description: "Passwords do not match.",
          });
          return;
        }
        let response = await axios.post(API_ENDPOINT + "/users/resetpassword", { email, otp, token: fpToken, password });
        api.success({
          message: "eGlu Service Forgot Password",
          description: "Password is successfully reset",
        });
        setIsCreating(false);
        setTimeout(() => {
          navigate("/login");
        }, 1000);
      } else {
        let response = await axios.post(API_ENDPOINT + "/users/forgotpassword", { email });
        api.success({
          message: "eGlu Service Forgot Password",
          description: "OTP is successfully sent to given Email ID",
        });
        setIsCreating(false);
        setOtpSent(true);
        setFpToken(response.data.token);
      }
    } catch (err) {
      api.error({
        message: "eGlu Service Forgot Password",
        description: err.response?.data?.message ?? "Failed to send OTP. Please try again",
      });
      setIsCreating(false);
    }
  };

  const onFinishFailed = () => {};

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <Row type="flex" justify="center" align="middle" style={{ minHeight: "100vh" }}>
      {contextHolder}
      <Col style={{ textAlign: "center" }}>
        <Lottie options={defaultOptions} height={100} width={100} />
        <h2 style={{ color: token.colorText }}>eGlu Service Forgot Password</h2>
        <div style={{ textAlign: "center", padding: 20 }} className="glass">
          <Form name="basic" style={{ maxWidth: 450 }} initialValues={{ remember: true }} onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete="off">
            <Form.Item label="Email ID" name="email" rules={[{ required: true, message: "Please input your Email!" }]}>
              <Input disabled={otpSent} />
            </Form.Item>

            {otpSent && (
              <Form.Item label="OTP" name="otp" rules={[{ required: true, message: "Please input OTP!" }]}>
                <Input style={{ textTransform: "uppercase" }} />
              </Form.Item>
            )}

            {otpSent && (
              <Form.Item label="Password" name="password" rules={[{ required: true, message: "Please input your Password!" }]}>
                <Input.Password />
              </Form.Item>
            )}

            {otpSent && (
              <Form.Item label="Repeat Password" name="passwordRepeat" rules={[{ required: true, message: "Please input your Password one more time!" }]}>
                <Input.Password />
              </Form.Item>
            )}

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={isCreating}>
                {otpSent ? `Reset Password` : `Send OTP`}
              </Button>
            </Form.Item>
          </Form>
        </div>
        <br />
        <br />
        <h4 style={{ color: token.colorText }}>
          <a href="/login" style={{ color: token.colorText, textDecoration: "underline" }}>
            Back to Login
          </a>
        </h4>
      </Col>
    </Row>
  );
};

export default ForgotPassword;
